module.exports = __webpack_public_path__ + "static/media/Icon_Kalender.41148a3d.png";